<!-- ABOUT ONE SECTION START -->
<!-- <div class="section-full p-t120 p-b90 bg-no-repeat bg-center bg-gray-light">
    <div class="about-section-one"> -->
       
        <div class="page-wraper">

            <app-header1></app-header1>
           
            <!-- <div class="page-content">
        
              
        
                <div class="section-full p-t30 p-b2 bg-gray-light">
                    <div class="container">
                       
                        <div class="section-head center wt-small-separator-outer text-center text-white">
                            <div class="wt-small-separator site-text-secondry">
                                <div class="sep-leaf-left"></div>
                                <div>Our Journey</div>
                            </div>
                            <div>
                                <ul>
                                    <li><img src="assets/images/journey.jpg" alt="Journey Image 1"></li>
                                    <li><img src="assets/images/timeline4.jpg" alt="Journey Image 2"></li>
                                </ul>
                            </div>
                        </div>
                        </div>
                        </div>
        
        
            </div> -->
            <!-- CONTENT END -->

            <!-- <div class="timeline-container">
                <h2 class="section-heading faq-h">Our Journey</h2>
            
                <div class="timeline">
                    <div class="timeline-item">
                        <div class="timeline-year">2018</div>
                        <div class="timeline-content left" data-aos="fade-right">
                            <h6>Opened the First Medical Center</h6>
                            <p>Marked the start of our healthcare journey in Colombo.</p>
                        </div>
                    </div>
            
                    <div class="timeline-item">
                        <div class="timeline-year">2019</div>
                        <div class="timeline-content right" data-aos="fade-left">
                            <h6>Regional Expansion</h6>
                            <p>Expanded to 14+ Medical Centers across South and Southeast Asia, strengthening our regional presence.</p>
                        </div>
                    </div>
            
                    <div class="timeline-item">
                        <div class="timeline-year">2020</div>
                        <div class="timeline-content left">
                            <h6>Global COVID-19 Operations</h6>
                            <p>Launched COVID-19 testing and onboarded 60+ corporate clients to support pandemic efforts.</p>
                        </div>
                    </div>
            
                    <div class="timeline-item">
                        <div class="timeline-year">2021</div>
                        <div class="timeline-content right">
                            <h6>Extended COVID-19 Programs</h6>
                            <p>Expanded vaccination programs and teleconsultation services, serving 30+ countries worldwide.</p>
                        </div>
                    </div>
            
                    <div class="timeline-item">
                        <div class="timeline-year">2022</div>
                        <div class="timeline-content left">
                            <h6>Healthcare Support for FIFA World Cup</h6>
                            <p>Introduced diagnostic and radiology services for global events.</p>
                        </div>
                    </div>
            
                    <div class="timeline-item">
                        <div class="timeline-year">2023</div>
                        <div class="timeline-content right">
                            <h6>Oncology and AI Diagnosis</h6>
                            <p>Expanded oncology services and entered AI-assisted diagnosis to enhance healthcare precision.</p>
                        </div>
                    </div>
            
                    <div class="timeline-item">
                        <div class="timeline-year">2024</div>
                        <div class="timeline-content left">
                            <h6>Soul Space and Mental Health Programs</h6>
                            <p>Established Soul Space for holistic mental well-being and launched AI-powered mental health programs.</p>
                        </div>
                    </div>
                </div>
            </div> -->
            
           <div class="timeline-cover">
                <div class="timeline">
                    <div class="timeline-line"></div>
                
                    <div *ngFor="let item of timelineData; let i = index" class="timeline-item">
                    
                    <!-- Year Circle (Click to Show Content) -->
                    <div class="timeline-year" 
                        [ngClass]="{ 'timeline-year-odd': i % 2 === 0, 'timeline-year-even': i % 2 !== 0, 'active': selectedIndex === i }"
                        (click)="toggleContent(i)">
                        {{ item.date }}
                    </div>
                
                    <!-- Timeline Content -->
                    <div class="timeline-content"
                        [ngClass]="{ 'timeline-content-odd': i % 2 === 0, 'timeline-content-even': i % 2 !== 0, 'active': selectedIndex === i }">
                        <h6>{{ item.title }}</h6>
                        <p>{{ item.description }}</p>
                    </div>
                
                    </div>
                </div>
           </div>
              
              
              
              <!-- [ngClass]="{ 'timeline-item-odd': i % 2 === 0, 'timeline-item-even': i % 2 !== 0 }" -->
            
            
              
            
            <app-footer1></app-footer1>

        </div>
        
       
        
        <app-loader></app-loader>
    <!-- </div>
</div> -->
<!-- ABOUT ONE SECTION END -->
<!-- <div class="section-head center wt-small-separator-outer text-center text-white">
    <div class="wt-small-separator site-text-secondry">
        <div class="sep-leaf-left"></div>
        <div>School Mental Health Programs</div>
    </div>
     

</div> -->